import React, { useEffect } from 'react';

export default function PrivacyPolicy() {
  useEffect(() => {
    // Load Termly.io embed script
    if (document.getElementById('termly-jssdk')) return;
    
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }, []);

  return (
    <div className="min-h-screen bg-theme-bg py-8 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-8">
        <h1 className="text-3xl font-bold text-theme-primary mb-6">Privacy Policy</h1>
        <div className="prose max-w-none">
          <div name="termly-embed" data-id="4100cc39-29fb-4401-ad41-bd78ff82f681" data-type="iframe"></div>
        </div>
      </div>
    </div>
  );
}

